export default __webpack_public_path__ + "static/media/dodecahedron.0dea1a6d.jpg";